const middleware = {}

middleware['idv'] = require('../middleware/idv.js')
middleware['idv'] = middleware['idv'].default || middleware['idv']

middleware['tfa'] = require('../middleware/tfa.js')
middleware['tfa'] = middleware['tfa'].default || middleware['tfa']

export default middleware
